module.exports = [
  {
    id: 1,
    type: 'invitedForInterview',
    buttonText: 'Приглашён на собеседование',
    text: 'Ждем вас на собеседование (дата и время) по адресу (адрес). Для регистрации на платформе необходимо выполнить 2 простых действия:\n'
      + ' 1. Загрузить фото паспорта (Более подробно во 2 разделе инструкции https://mygig.zendesk.com/hc/ru/articles/360007585157-Как-работает-My-Gig-) \n'
      + '2. Подтвердить статус самозанятого (Более подробно в 5 разделе инструкции https://mygig.zendesk.com/hc/ru/articles/360007585157-Как-работает-My-Gig-) \n'
      + 'Ответы на часто задаваемые вопросы, а также подробную информацию о том, как пользоваться сервисом вы найдете тут https://mygig.zendesk.com/hc/ru/categories/360001326357-Исполнителю; \n'
      + 'Видео-инструкция - https://www.youtube.com/channel/UCXEwPdQKReq4dYL-SOF_4Rw/videos \n'
      + 'При возникновении любых вопросов можете обратиться в нашу техническую поддержку: \n'
      + '• По телефону: +7 (495) 215-53-58\n'
      + ' • В телеграмме: https://t.me/MyGigBot\n'
      + ' • Вконтакте: https://vk.com/public195322973',
    toReplace: [['(дата и время)', 'date'], ['(адрес)', 'address']],
  },
  {
    id: 2,
    type: 'failedToGetThrough',
    buttonText: 'Не удалось дозвониться',
    text: 'Здравствуйте, не удалось до вас дозвониться. У нас есть для вас работа. Перезвоните нам по тел. 88003330329 и мы расскажем подробнее. Звонок бесплатный.',
    toReplace: [],
  },
  {
    id: 3,
    type: 'withoutTemplate',
    buttonText: 'Без шаблона',
    text: '',
    toReplace: [],
  },
];
